import React from "react";

const BadgeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.3162 20.7334V28.5177L13.8216 26.5666L7.30664 28.5177V20.7334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M21.1535 20.7334V29.0004L13.8216 27.17L7.30664 28.5177V20.7334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M13.965 22.5838C20.0671 22.5838 25.0139 17.9099 25.0139 12.1444C25.0139 6.37893 20.0671 1.70508 13.965 1.70508C7.86279 1.70508 2.91602 6.37893 2.91602 12.1444C2.91602 17.9099 7.86279 22.5838 13.965 22.5838Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M26.179 11.9834C26.179 19.466 20.052 22.8854 13.9251 22.8854C11.0742 22.7647 8.38081 21.5644 6.40689 19.535C4.43298 17.5056 3.33105 14.8038 3.33105 11.9935C3.33105 9.18315 4.43298 6.48138 6.40689 4.45196C8.38081 2.42254 11.0742 1.22225 13.9251 1.10156C19.9907 1.10156 26.179 5.26523 26.179 11.9834Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M14.3331 5.26465L16.4367 9.46855L18.7956 9.80043L21.1545 10.1323L17.7438 13.411L18.5607 18.0171L14.3331 15.8448L10.126 18.0171L10.9429 13.411L7.53223 10.1323L12.2296 9.46855L14.3331 5.26465Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
  </svg>
);

export default BadgeIcon;
